import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../firebase/config';
import { doc, getDoc } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { fetchAssignment, deleteAssignment } from '../Api';

const Profile = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [assignments, setAssignments] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        navigate('/login');
        return;
      }

      try {
        const docRef = doc(db, 'candidates', user.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setUserData({
            uid: user.uid,
            email: user.email,
            ...docSnap.data(),
          });
        } else {
          // If no Firestore document, fallback to auth user data
          setUserData({
            uid: user.uid,
            email: user.email,
          });
        }
        localStorage.setItem('loggedInUserId', user.uid);
        const assignmentRes = await fetchAssignment();
        if (assignmentRes.status) {
          setAssignments(assignmentRes.data);
        } else {
          console.warn(assignmentRes.message);
        }
      } catch (error) {
        console.error('Error fetching user data or assignments:', error);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  // Disable right-click and common inspect shortcuts
  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();
  
    const handleKeyDown = (e) => {
      if (e.key === 'F12') {
        e.preventDefault();
        return false;
      }
      if (
        (e.ctrlKey || e.metaKey) && 
        (e.shiftKey && ['I', 'J', 'C', 'K'].includes(e.key.toUpperCase()))
      ) {
        e.preventDefault();
        return false;
      }
      if (
        (e.ctrlKey || e.metaKey) &&
        ['U', 'S', 'P'].includes(e.key.toUpperCase())
      ) {
        e.preventDefault();
        return false;
      }
    };
  
    window.addEventListener('contextmenu', handleContextMenu);
    window.addEventListener('keydown', handleKeyDown);
  
    return () => {
      window.removeEventListener('contextmenu', handleContextMenu);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  // Handle Delete Action
  const handleDelete = async (id) => {
    const confirmed = window.confirm('Are you sure you want to delete this assignment?');
    if (!confirmed) return;

    try {
      const response = await deleteAssignment(id);
      if (response.status) {
        // Filter out the deleted assignment
        setAssignments((prev) => prev.filter((item) => item.id !== id));
        alert('Assignment deleted successfully!');
      } else {
        alert(response.message || 'Failed to delete the assignment.');
      }
    } catch (error) {
      console.error('Error deleting assignment:', error);
      alert('An error occurred while deleting the assignment.');
    }
  };

  if (loading) return <div className="text-center mt-5">Loading profile...</div>;

  if (!userData) return null;
  // console.log(userData);

  return (
    <>
    <Header />
    <div className="profile-container mt-5">
      <h2 className="profile-heading mb-4">Hello {userData.firstName},</h2>
      <div className="card shadow-lg mb-5">
        <div className="profile-card">
          {/* <p><strong>UID:</strong> {userData.uid}</p> */}
          <p><strong>Email:</strong> {userData.email}</p>
          {userData.firstName && <p><strong>First Name:</strong> {userData.firstName}</p>}
          {userData.lastName && <p><strong>Last Name:</strong> {userData.lastName}</p>}
          {userData.phone && <p><strong>Phone:</strong> {userData.phone}</p>}
          {userData.fullName && <p><strong>Full Name:</strong> {userData.fullName}</p>}
        </div>
      </div>

      {/* Assignment Table */}
        <div className="card shadow-lg">
          <div className="table-container">
            <h4 className="mb-3">Your uploads</h4>
            {assignments.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead className="table-dark">
                    <tr>
                      <th>S.no</th>
                      <th>Full Name</th>
                      <th>Email</th>
                      <th>Course</th>
                      <th>Message</th>
                      <th>File</th>
                      <th>Submitted On</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {assignments.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.full_name}</td>
                        <td>{item.email}</td>
                        <td>{item.course_category}</td>
                        <td>{item.message || '-'}</td>
                        <td>
                          {item.file_path ? (
                            <a href={item.file_path} target="_blank" rel="noopener noreferrer">View</a>
                          ) : '-'}
                        </td>
                        <td>{item.formattedCreatedAt}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => handleDelete(item.id)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-muted">No assignments submitted yet.</p>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Profile;
